import {
  UNIVERSITY_IMAGE_AC_IMAGE_TYPE_FAILED,
  UNIVERSITY_IMAGE_AC_IMAGE_TYPE_REQ,
  UNIVERSITY_IMAGE_AC_IMAGE_TYPE_RESET,
  UNIVERSITY_IMAGE_AC_IMAGE_TYPE_SUCCESS,
  UPLOAD_UNIVERSITY_IMAGE_FAILED,
  UPLOAD_UNIVERSITY_IMAGE_REQ,
  UPLOAD_UNIVERSITY_IMAGE_RESET,
  UPLOAD_UNIVERSITY_IMAGE_SUCCESS,
} from "../Constants/universityImageUploadConstant";

export const UNIVERSITY_IMAGE_DETAILS_AC_UNIVERSITY_REDUCER = (
  state = {},
  { type, payload }
) => {
  switch (type) {
    case UNIVERSITY_IMAGE_AC_IMAGE_TYPE_REQ: {
      return { University_Image_Ac_Type_Loading: true };
    }
    case UNIVERSITY_IMAGE_AC_IMAGE_TYPE_SUCCESS: {
      return {
        University_Image_Ac_Type_Loading: false,
        University_Image_Ac_Type: payload,
      };
    }
    case UNIVERSITY_IMAGE_AC_IMAGE_TYPE_FAILED: {
      return {
        University_Image_Ac_Type_Loading: false,
        University_Image_Ac_Type_Error: payload,
      };
    }
    case UNIVERSITY_IMAGE_AC_IMAGE_TYPE_RESET: {
      return {};
    }
    default:
      return state;
  }
};

export const UNIVERSITY_IMAGE_UPLOAD_REDUCER = (
  state = {},
  { type, payload }
) => {
  switch (type) {
    case UPLOAD_UNIVERSITY_IMAGE_REQ: {
      return { Upload_University_Images_Loading: true };
    }
    case UPLOAD_UNIVERSITY_IMAGE_SUCCESS: {
      return {
        Upload_University_Images_Loading: false,
        Upload_University_Images_Success: payload,
      };
    }
    case UPLOAD_UNIVERSITY_IMAGE_FAILED: {
      return {
        Upload_University_Images_Loading: false,
        Upload_University_Images_Error: payload,
      };
    }
    case UPLOAD_UNIVERSITY_IMAGE_RESET: {
      return {};
    }
    default:
      return state;
  }
};
